function formatCnpj(cnpj) {
  let newCnpj = cnpj;

  if (typeof cnpj !== 'string') {
    newCnpj = cnpj.toString();
  }

  if (!newCnpj || newCnpj.length !== 14) {
    return newCnpj;
  }


  return `${newCnpj.substr(0, 2)}.${newCnpj.substr(2, 3)}.${newCnpj.substr(5, 3)}/${newCnpj.substr(8, 4)}-${newCnpj.substr(12, 2)}`;
}

export default formatCnpj;
